import * as Yup from 'yup';
import { TLegacyUserRole } from '../../api/types/UserRole';
import { TLegacyUser } from '../../api/types/User';

export type TDuplicateReportFormFieldName = "report_name";

export const duplicateReportInitialValues = {
    report_name: "",
}

export const duplicateReportValidationSchema = Yup.object().shape({
    report_name: Yup.string().required('Required'),
});

type TShareTo = "all_users" | "roles" | "selected_users";

export const shareReportInternallyInitialValues = {
    share_to: "all_users" as TShareTo,
    selected_roles: [] as string[] | {label:string , value:string}[],
    selected_users: [] as string[] | {label:string , value:string}[]
}

export const shareReportInternallyValidationSchema = Yup.object().shape({

});

export type TFormFieldShareViaEmailNames = "selected_emails" | "email" | "download_type" | "send_automatically" | "send_automatically_period" | "day_of_month" | "day_of_month2" | "day_of_week" | "delay_time";

export type TDownloadType = "xls" | "pdf" | "csv";

export type TSendAutomaticallyPeriod = "hourly" | "daily" | "weekly" | "monthly" | "bi_monthly";

export const shareViaEmailInitialValues = {
    selected_emails: [] as string[],
    email: "",
    download_type: "xls" as TDownloadType,
    send_automatically: false,
    send_automatically_period: "hourly" as TSendAutomaticallyPeriod,
    day_of_month: "1",
    day_of_month2: "1",
    day_of_week: "monday",
    delay_time: "00:00",
}

export const shareViaEmailValidationSchema = Yup.object().shape({
    emails: Yup.array()
        .min(1, 'At least one email is required'),
    email: Yup.string()
        .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Please enter a valid email address'),
});

export type TEmails = {
    emails: string;
}

type TReportFor = "asset" | "group" | "driver";

type TCategory = "ASSET_DETAIL" | "DEVICE_GROUP_DETAIL" | "DEVICE_GROUP_SUMMARY" | "ASSET_PERFORMANCE" | "DRIVER_PERFORMANCE" | "IFTA";

export const addNewReportInitialValues = {
    report_name: "",
    report_for: "asset" as TReportFor,
    category: "ASSET_DETAIL" as TCategory,
    sub_category: "",
}

export const addNewReportValidationSchema = Yup.object().shape({
    report_name: Yup.string().required('Please enter a name for the report').max(255, 'Maximum 255 characters'),
    category: Yup.string().required('Please select a category'),
    sub_category: Yup.string().required('Please select a sub-category'),
});